<div class="content-container h-full flex flex-col justify-between" #pageTop>
  <div>
    @if (isLoading()) {
      <lib-overlay-loader />
    }

    <h1 class="text-xl leading-7 font-semibold text-neutral-900 pb-md mb-2xl">
      {{ pageTitle() }}
    </h1>

    <form [formGroup]="profileFormGroup()">
      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 mb-lg">
          {{ 'edit_profile_screen_profile_image_section_title' | transloco }}
        </h5>

        <div class="image-section">
          <div>
            <lib-upload-files
              [uploadedFiles]="uploadedImage()"
              [id]="'image'"
              [name]="'image'"
              [uploadUrl]="uploadFileUrls.upload"
              [removeUrl]="uploadFileUrls.remove"
              [label]="'group_form_screen_upload_image_label' | transloco"
              [inputFormControlName]="'image'"
              [accept]="'jpg,jpeg,png,webp'"
              [multiple]="false"
              [fileSizeLimit]="2048 * 1000"
              [viewOnly]="false"
              [required]="false"
              [uploadedFileLimit]="1"
              [uploadFileLabels]="{
                placeholder: 'upload_files_placeholder' | transloco,
                singleFileAttachedLabel:
                  'upload_files_single_file_attached_label' | transloco,
                multipleFilesAttachedLabel:
                  'upload_files_multiple_files_attached_label' | transloco,
                addMoreLabel: 'upload_files_add_more_label' | transloco,
                attachmentsTitle: 'upload_files_attachments_title' | transloco,
                fileUploadTitle: 'upload_files_file_upload_title' | transloco,
                dragAndDropLabel:
                  'upload_files_drag_and_drop_label' | transloco,
                orLabel: 'upload_files_or_label' | transloco,
                uploadFromComputerLabel:
                  'upload_files_upload_from_computer_label' | transloco,
                maxSizeLabel: 'upload_files_max_size_label' | transloco,
                perFileLabel: 'upload_files_per_file_label' | transloco,
                maxFilesLimitLabel:
                  'upload_files_max_files_limit_label' | transloco,
                cancelButtonLabel:
                  'upload_files_cancel_button_label' | transloco,
                continueButtonLabel:
                  'upload_files_continue_button_label' | transloco,
                singleFileUploadedLabel:
                  'upload_files_single_file_uploaded_label' | transloco,
                multipleFilesUploadedLabel:
                  'upload_files_multiple_files_uploaded_label' | transloco,
                singleFileLabel: 'upload_files_single_file_label' | transloco,
                multipleFilesLabel:
                  'upload_files_multiple_files_label' | transloco,
                allFormatsAcceptedLabel:
                  'upload_files_all_formats_accepted_label' | transloco,
                acceptedFormatLabel:
                  'upload_files_accepted_format_label' | transloco,
                acceptedFormatsLabel:
                  'upload_files_accepted_formats_label' | transloco,
                uploadedLabel: 'upload_files_uploaded_label' | transloco,
                deleteWarningPopupTitle:
                  'edit_profile_screen_upload_image_warning_popup_title'
                  | transloco,
                deleteWarningPopupDeclaimerMessage:
                  'upload_image_warning_popup_declaimer_message' | transloco,
                deleteWarningPopupCancelButton:
                  'upload_image_warning_popup_cancel_button' | transloco,
                deleteWarningPopupContinueButton:
                  'upload_image_warning_popup_delete_button' | transloco,
              }" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="image" />
          </div>
        </div>
      </section>

      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 mt-2xl mb-lg">
          {{ 'edit_profile_screen_profile_info_section_title' | transloco }}
        </h5>

        <div class="info-section gap-lg">
          <div>
            <lib-input
              [inputFormControlName]="'first_name'"
              [id]="'first_name'"
              type="text"
              name="first_name"
              [required]="true"
              [disabled]="true"
              [label]="'edit_profile_screen_first_name_label' | transloco"
              [placeholder]="
                'edit_profile_screen_first_name_placeholder' | transloco
              " />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="first_name" />
          </div>

          <div>
            <lib-input
              [inputFormControlName]="'last_name'"
              [id]="'last_name'"
              type="text"
              name="last_name"
              [required]="true"
              [disabled]="true"
              [label]="'edit_profile_screen_last_name_label' | transloco"
              [placeholder]="
                'edit_profile_screen_last_name_placeholder' | transloco
              " />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="last_name" />
          </div>

          <div>
            <lib-mobile-input
              [inputFormControlName]="'phone'"
              [id]="'phone'"
              [name]="'phone'"
              [label]="'edit_profile_screen_phone_number_label' | transloco"
              [required]="true"
              [searchPlaceholder]="
                'phone_number_search_placeholder' | transloco
              "
              [selectedCountry]="selectedCountryISO()"
              [selectedPhoneNumber]="selectedPhoneNumber()" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="phone"
              [customErrorMessages]="{
                pattern:
                  'edit_profile_screen_phone_number_pattern_error_message'
                  | transloco,
              }" />
          </div>

          <div>
            <lib-input
              [inputFormControlName]="'email'"
              [id]="'email'"
              type="email"
              name="email"
              [required]="true"
              [disabled]="true"
              [label]="'edit_profile_screen_email_address_label' | transloco"
              [placeholder]="'Email@Example.com'" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="email" />
          </div>

          <div [formGroupName]="'position'">
            <lib-select
              [inputFormControlName]="'job_title_id'"
              id="job_title_id"
              name="job_title_id"
              [label]="'edit_profile_screen_job_title_label' | transloco"
              [placeholder]="
                'edit_profile_screen_job_title_placeholder' | transloco
              "
              [required]="true"
              [disabled]="true"
              [options]="jobTitles()"
              [selectedKeyValue]="'id'"
              [selectedKeyName]="'name'" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="job_title_id" />
          </div>
        </div>
      </section>
    </form>
  </div>

  <footer class="flex justify-end items-end pb-2xl">
    <div class="flex justify-end gap-lg mt-2xl">
      <a
        id="edit_profile_screen_discard_button"
        class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium cursor-pointer"
        [routerLink]="[
          `${EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.PROFILE_DETAILS}` | tenantPath,
        ]">
        {{ 'edit_profile_screen_discard_button' | transloco }}
      </a>

      <button
        id="edit_profile_screen_save_edits_button"
        class="px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none cursor-pointer"
        (click)="submit()"
        [class.opacity-30]="
          !isFormChanged() || !profileFormGroup().valid || isLoading()
        "
        [disabled]="
          !isFormChanged() || !profileFormGroup().valid || isLoading()
        ">
        {{ buttonText() }}
      </button>
    </div>
  </footer>
</div>
